import { Moment } from "moment";
import { ContactDetails } from "../CommonProps";
import { LoanAssign } from "../modals/LoanAssign";
import { LoanCar } from "../modals/LoanCar";
import { LoanCarBooking } from "../modals/LoanCarBooking";
import { JobEstimationDetail } from "../modals/JobEstimationDetail";
import { IBSAdonisService } from "./IBSAdonisService";

const ibsAdonisService = new IBSAdonisService();

export const getAvailableLockBoxes = async (
  day: Moment
): Promise<LoanCar[]> => {
  // Fetch all loan cars and filter for active lock boxes
  const loanCarsResponse: any = await ibsAdonisService.getLoanCars();
  const lockBoxes: LoanCar[] = loanCarsResponse.filter(
    (x: LoanCar) => x.classification === "Lock Box" && x.inactive === false
  );

  // Fetch loan car bookings for the given day
  const lockBoxAssigns: LoanAssign[] = await ibsAdonisService.getLoanCarsBookings(
    day.format("YYYY-MM-DDTHH:mm:ss"),
    day.format("YYYY-MM-DDTHH:mm:ss")
  );

  // Filter out lock boxes that are already assigned
  const availableLockBoxes = lockBoxes.filter(
    (x) => !lockBoxAssigns.some((a: LoanAssign) => a.loanCarId === x.id)
  );

  return availableLockBoxes;
};

export const bookLoanCar = async (
  date: Moment,
  estimateDetails: JobEstimationDetail,
  loanCar: LoanCar
) => {
  try {
    const contactDetails: ContactDetails = {
      mobilePhone: estimateDetails.mobilePhone,
      emailAddress: estimateDetails.email,
      firstName: estimateDetails.firstName,
      lastName: estimateDetails.lastName,
      displayName: estimateDetails.ownerName
    };
    const body: LoanCarBooking = {
      contact: contactDetails,
      dateFrom: date.format("YYYY-MM-DDT00:00"),
      dateTo: date.format("YYYY-MM-DDT23:59"),
      driver: {
        contactDetails: {}
      },
      estimateId: estimateDetails.estimateId,
      estimateNumber: estimateDetails.estimateNumber.toString(),
      loanCarId: loanCar.id
    };

    return await ibsAdonisService.createLoanCarBookings(body);
  } catch (error) {
    console.error("🚀 ~ error:", error)

  }
};
